module.exports = __webpack_public_path__ + "static/media/pt-ecosentino-bathroom-days-small.533c004a.png";